
































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import ModalDelete from '@/app/ui/components/ModalDelete/index'
import { FAQModule } from '@/app/store/modules/faq'
@Component({
  components: {
    'modal-delete': ModalDelete,
  },
})
export default class extends Vue {
  @Prop({}) public onPageLimit
  @Prop({}) public onPageNumChanged
  @Prop({}) public dataTable
  @Prop({}) public fields: any[] | undefined
  @Prop({}) public selected: any[] | undefined
  @Prop({}) public clearTableStatus
  @Prop({}) public isLoading

  @Watch('clearTableStatus')
  public onPropertyChanged(value: boolean, oldValue: boolean) {
    this.$refs.selectableTable.clearSelected()
  }
  public get isFilledDataTable() {
    return (
      this.dataTable !== undefined && this.dataTable.pagination !== undefined
    )
  }
  public modalDelete = {
    id: 'modal-delete',
    idFaq: 0,
    title: '',
  }
  public optionsIsActive = [
    { text: 'Active', value: true },
    { text: 'Inactive', value: false },
  ]
  public $refs!: {
    selectableTable: HTMLFormElement
  }
  public postData: any = {
    id: 'modal-edit',
    idFaq: 0,
    question: '',
    answer: '',
    isActive: true,
  }

  public onRowSelected(items) {
    this.$emit('onRowSelected', items)
  }
  public selectAllRows() {
    if (this.$props.selected.length === this.dataTable.data.length) {
      this.$refs.selectableTable.clearSelected()
    } else {
      this.$refs.selectableTable.selectAllRows()
    }
  }

  public funcEdit(item, index, button) {
    //  console.log('item', item)
    if (this.$props.selected.length < 1) {
      this.postData.idFaq = item.id
      this.postData.question = item.question
      this.postData.answer = item.answer
      this.postData.isActive = item.isActive
      this.$root.$emit('bv::show::modal', this.postData.id, button)
    }
  }

  public patchNotif(item, index, button) {
    if (this.stateAnswer === false || this.stateQuestion === false) {
      return
    } else {
      const dataToEdit = {
        id: this.postData.idFaq,
        question: this.postData.question,
        answer: this.postData.answer,
        isActive: this.postData.isActive,
      }
      FAQModule.updateFAQ(dataToEdit)
      this.$root.$emit('bv::hide::modal', 'modal-edit', button)
    }
  }
  public funcDelete(item, index, button) {
    if (this.$props.selected.length < 1) {
      this.modalDelete.title = item.question
      this.modalDelete.idFaq = item.id
      this.$root.$emit('bv::show::modal', this.modalDelete.id, button)
    }
  }

  public deleteNotif() {
    const ids = [this.modalDelete.idFaq]
    FAQModule.deleteFAQ({ ids })
    this.$root.$emit('bv::hide::modal', 'modal-delete')
  }

  public resetEditModal() {
    this.postData.idFaq = 0
    this.postData.question = ''
    this.postData.answer = ''
    this.postData.status = 'Active'
  }
  public resetDeleteModal() {
    this.modalDelete.title = ''
  }

  public get stateQuestion(): boolean {
    return this.postData.question.length >= 4 ? true : false
  }
  public get stateAnswer(): boolean {
    return this.postData.answer.length >= 4 ? true : false
  }
  public get invalidQuestion(): string {
    if (this.postData.question.length > 4) {
      return ''
    } else if (this.postData.question.length > 0) {
      return 'Enter at least 4 characters'
    } else {
      return 'Please enter Question'
    }
  }
  public get invalidAnswer(): string {
    if (this.postData.answer.length > 4) {
      return ''
    } else if (this.postData.answer.length > 0) {
      return 'Enter at least 4 characters'
    } else {
      return 'Please enter Answer'
    }
  }
  public get validQuestion(): string {
    return this.stateQuestion === true ? '' : ''
  }
  public get validAnswer(): string {
    return this.stateAnswer === true ? '' : ''
  }

  public get buttonDisable(): boolean {
    if (this.$props.selected.length < 1) {
      return false
    } else {
      return true
    }
  }
}
